
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  // 测试 setup是组合 API中第一个要使用的代码
  setup() {
    return {
      a: 123
    }
  }
});
